import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dateFilterTitle: {
		id: 'software-deployments.date-filter.popup-content.date-filter-title',
		defaultMessage: 'Date Range',
		description: 'Title description for popup where users can select their desired date range',
	},
	pastTwoWeeksLabel: {
		id: 'software-deployments.date-filter.popup-content.past-two-weeks-label',
		defaultMessage: 'Past 2 weeks',
		description: 'Label for selecting the past week option',
	},
	pastMonthLabel: {
		id: 'software-deployments.date-filter.popup-content.past-month-label',
		defaultMessage: 'Past month',
		description: 'Label for selecting the past month option',
	},
	pastQuarterLabel: {
		id: 'software-deployments.date-filter.popup-content.past-quarter-label',
		defaultMessage: 'Past quarter',
		description: 'Label for selecting the past quarter option',
	},
	pastYearLabel: {
		id: 'software-deployments.date-filter.popup-content.past-year-label',
		defaultMessage: 'Past year',
		description: 'Label for selecting the past year option',
	},
	customRangeLabel: {
		id: 'software-deployments.date-filter.popup-content.custom-range-label',
		defaultMessage: 'Custom Range',
		description: 'Label for selecting the custom range option',
	},
});
